import React from 'react';
import { Loader2 } from '../../icons';

export const Loading = () => (
    <div className="col-12 text-center py-4">
        <Loader2 size={36} className="text-primary" style={{ animation: 'spin 1s linear infinite' }} />
        <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
);
